module.exports = {
  'Need more time?': '¿Necesitas más tiempo?',
  'Your session will automatically close in': 'Tu sesión se cerrará automáticamente en',
  'seconds': 'secondes',
  'second': 'seconde',
  'Make sure not to leave incomplete information, otherwise it won’t be saved.':
  'Asegúrate de no dejar información incompleta, de lo contrario no se guardará.',
  'Stay in session': 'Permanecer en la sesión',
};
